export enum FiltersPaneMode {
  Document = 1,
  Navigation = 2,
  Upload = 3
}